<template>
  <div class="dt-infowindow-box">
    <p class="dt-infowindow-title" v-if="title">{{title}}</p>
    <div class="dt-overflow">
      <table class="dt-infowindow-table">
        <tr v-for="(item, index) in itemConts" :key="'tr_'+index" v-if="notShowKeys.indexOf(item.name) === -1">
          <td class="field-name">
            <span :class="{ width4bit: isAllChinese(item.name) && item.name.length <= 4 }">{{item.name}}</span>
          </td>
          <td v-if="item.name==='通勤方式'">
            <div v-for="vehicle in item.vehicles">
              <span class="rout-type-name">{{vehicle.name}}</span>
              <span>{{vehicle.cont}}</span>
            </div>
          </td>
          <td v-else>{{item.cont}}</td>
        </tr>
      </table>
    </div>
    <div class="dt-infowindow-bottom" v-if="false"></div>
  </div>
</template>
<script>
import '../assets/stylesheets/infowindow.scss';
import { isAllChinese } from '../assets/javascript/utils';
let notShowKeys = ['orId'];
export default {
  data() {
    return {
      itemConts: [],
      notShowKeys: notShowKeys,
      isAllChinese: isAllChinese
    };
  },
  props: ["data"],
  computed: {
    title() {
      if (this.itemConts && this.itemConts.length > 0) {
        for (let i = 0, n = this.itemConts.length; i < n; i++) {
          let item = this.itemConts[i];
          if (item.name === 'name') {
            return item.cont;
          }
        }
      }
      return '';
    }
  },
  mounted() {
    this.setTable();
  },
  methods: {
    setTable: function() {
      this.itemConts = this.data;
    }
  }
};
</script>
<style lang="less">
.rout-title {
  min-width: 60px;
  vertical-align: top;//靠上对齐
  text-align:justify;//两端对齐
  text-justify:distribute-all-lines;
  text-align-last:justify;
}
.rout-type-name {
  background-color: #3f9488;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/InfowindowLine.vue